import React from "react";
// Import the requested icons from lucide-react
import { Phone, Instagram, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    // Kept the parent className "contact" as requested
    <div className="contact" id="contact">

      <h1>STILL</h1>

      {/* Replaced the old h2/h3 structure with a semantic list.
        This groups all contact items together as seen in the image.
      */}
      <ul className="contact-list">
        <li>
          <Phone size={25} />
          <a href="tel:+918445339002">+91 8445339002</a>
        </li>
        <li>
          <Instagram size={25} />
          <a href="http://www.instagram.com/still.india" target="_blank" rel="noopener noreferrer">
            @still.india
          </a>
        </li>
        <li>
          <Mail size={25} />
          <a href="mailto:support@stillshoes.com">support@stillshoes.com</a>
        </li>
        <li>
          <MapPin size={25} />
          <span>C-23, Rajendrapuram, Meerut, UP (250001)</span>
        </li>
        <li>
          <Clock size={25} />
          <span>Working Hours: Mon - Fri - 10am to 6pm</span>
        </li>
      </ul>

      {/* --- Policy Links --- */}
      <div className="footer-policies">
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        <span>|</span>
        <a href="/shipping-policy" target="_blank" rel="noopener noreferrer">
          Shipping Policy
        </a>
        <span>|</span>
        <a href="/return-policy" target="_blank" rel="noopener noreferrer">
          Return & Refund Policy
        </a>
        <span>|</span>
        <a href="/terms-and-conditions-policy" target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </a>
      </div>


      {/* Added the copyright section from the image */}
      <div className="footer-copyright">
        <p>©2025 SHUSH Footwear LLP. Trading as STILL™. All rights reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
